// SEOLayout.jsx
import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

export default function SEOLayout({ children }) {
  const { pathname } = useLocation();

  const canonical = `https://wayoai.app${pathname}`.replace(/\s/g, "%20");

  return (
    <>
      <Helmet>
        <link rel="canonical" href={canonical} />
        <meta name="robots" content="index, follow, max-image-preview:large" />
      </Helmet>
      {children}
    </>
  );
}
